<template>
  <div :class="$x.dateFormWrap">
    <div :class="$x.dateForm">
      <VForm ref="dateForm" name="dateForm">
        <NsCreditCardDate
          v-model="cardDate"
          :translations="t.creditCardDate"
          class="date-field"
          :field-disabled="disableDate"
          @input="updateExpireDate"
          @date-valid-state="setValid"
        ></NsCreditCardDate>
      </VForm>
      <VBtn
        class="v-btn-hit-solid short"
        :class="$x.formContinue"
        name="selectCvv"
        :loading="loading"
        @click="doContinue"
      >
        {{ t.continue }}
      </VBtn>
    </div>
  </div>
</template>

<script>
/**
 * Original Author: Treg Anderson
 * Original Team: Mavericks
 */
import { VForm, VBtn } from 'vuetify/lib';
import NsCreditCardDate from './NsCreditCardDate.vue';

export default {
  name: 'NsExpireDateForm',
  components: {
    NsCreditCardDate,
    VForm,
    VBtn,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },

    translations: {
      type: Object,
      default() {
        return {
          continue: 'Continue',
          creditCardDate: {
            invalidDate: 'Invalid Date Entered',
            label: 'Expiration Date',
            monthPlaceholder: '',
            yearPlaceholder: '',
            fieldRequired: 'Required',
          },
        };
      },
    },
  },
  data() {
    return {
      cardDate: {
        expMonth: this.value.expMonth,
        expYear: this.value.expYear,
      },
      dateValid: false,
      disableDate: false,
      loading: false,
      t: this.translations,
    };
  },
  watch: {
    translations() {
      this.t = this.translations;
    },

    value() {},
  },
  mounted() {},
  methods: {
    doContinue() {
      if (this.dateValid) {
        this.loading = true;
        this.$emit('input', { ...this.cardDate });
      }
    },
    setValid(valid) {
      this.dateValid = valid;
    },
    updateExpireDate(value) {
      this.$set(this.cardDate, 'expMonth', value.expMonth);
      this.$set(this.cardDate, 'expYear', value.expYear);
    },
  },
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";
@use "~@nuskin/ns-core-styles/src/scss/vuetifyOverrides";

.dateFormWrap {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  line-height: 1.3em;
}

.dateForm {
  display: flex;
  position: relative;
  .formContinue {
    width: 100px;
    height: 34px;
    margin-top: 24px !important;
    padding: 0 20px 0 20px;
    @media screen and (max-width: 767px) {
      margin-top: 4px;
    }
  }
}
</style>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";
@use '~@nuskin/ns-core-styles/src/scss/colors';

*:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, 'font-family-primary');
}
</style>

<style lang="scss">
[class^='NsExpireDateForm_'] {
  .date-field {
    max-width: 220px;
    margin-right: 8px;
  }
}
</style>
